import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { first, get, isEmpty, isNil, map } from 'lodash';
import { closeModal } from '../../../../common/components/Modal/ModalRedux';
import { Button, DatePickerLeisure, Icon, Modal } from '../../../../common/components';
import './PolicyUpsell.scss';
import { RadioGroup, SelectField } from '../../../../common/components/ReduxFormField';
import { Row, Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { addDays } from 'date-fns';

const PREMIUM_META = 'premiumIndication.meta.information';
const FORM_META = 'data.attributes.metadata';

const FORM_NAME = 'PolicyUpsell';

class PolicyUpsell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpgradeDirty: false,
      isUpgradeDirtyRegion: false,
    };
  }

  componentWillReceiveProps() {
    const { formValues, change, product, dispatch } = this.props;

    const formMaxTrip = get(formValues, `${FORM_META}.max_trip_duration_display_only`);
    const formRegion = get(formValues, `${FORM_META}.storage.region_display_only`);

    const selectedScheme = get(first(this.props.selectedSchemes), 'id');

    const regionInfo = get(product, `quotes.${selectedScheme}.meta.information.region`);

    const maxTripInfo = get(product, `${PREMIUM_META}.max_trip_duration`);

    if (
      !isNil(maxTripInfo) &&
      (maxTripInfo !== formMaxTrip && !this.state.isUpgradeDirty)
    ) {
      dispatch(change(`${FORM_META}.max_trip_duration_display_only`, maxTripInfo));
      this.setState({
        isUpgradeDirty: true,
      });
    }

    if (
      !isNil(regionInfo) &&
      (regionInfo !== formRegion && this.state.isUpgradeDirtyRegion === false)
    ) {
      dispatch(change(`${FORM_META}.storage.region_display_only`, regionInfo));
      this.setState({
        isUpgradeDirtyRegion: true,
      });
    }
  }

  handleUpsell = () => {
    const { dispatch, confirmUpsell } = this.props;
    confirmUpsell();
    dispatch(closeModal(FORM_NAME));
  };

  handleOnHide() {
    const { change } = this.props;
    change('data.relationships.schemes.data', []);
  }

  render() {
    const { product, submitting, currentProduct, formValues } = this.props;

    const mapToReactSelect = (options, toInt) => {
      return map(options, (name, key) => {
        return {
          label: name,
          value: toInt ? Number.parseInt(key) : key,
        };
      });
    };
    const isLoading =
      product.isUpdatingPremiumIndication &&
      isEmpty(get(formValues, `${FORM_META}.region`, ''));
    const regions = mapToReactSelect(get(currentProduct, `${FORM_META}.regions`, {}));
    const annualTripDuration = mapToReactSelect(
      get(currentProduct, `${FORM_META}.annual_trip_durations`, {}),
      true,
    );
    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        disabled={product.isCalculating}
        isLoading={submitting}
        label="Continue to Upsell"
        handleClick={this.handleUpsell}
      />
    );

    return (
      <div style={{ clear: 'both' }}>
        <Modal
          name={FORM_NAME}
          title={'Policy Upsell'}
          close
          footer={submitButton}
          onHide={this.handleOnHide.bind(this)}
          className={'modal'}
        >
          <div className="form-horizontal policy-upsell-container">
            <div className="policy-upsell-header">
              You have selected to upsell to Annual Multi-Trip cover. Please check that
              the details below are correct before you continue with this upsell.
            </div>
            <FormGroup>
              <Col sm={5}>
                <ControlLabel>Start Date</ControlLabel>
              </Col>
              <Col sm={7}>
                <Field
                  name="data.attributes.metadata.start_date"
                  maxDate={addDays(new Date(), 90)}
                  minDateToday
                  component={DatePickerLeisure}
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={5}>
                <ControlLabel>Duration of longest trip</ControlLabel>
              </Col>
              <Col sm={7}>
                <Field
                  name="data.attributes.metadata.max_trip_duration_display_only"
                  component={SelectField}
                  options={annualTripDuration}
                />
              </Col>
              <Col sm={1}>
                {isLoading && (
                  <ControlLabel>
                    <Icon spin name="spinner" />
                  </ControlLabel>
                )}
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={5}>
                <ControlLabel>Region</ControlLabel>
              </Col>
              <Col sm={7}>
                <Field
                  name="data.attributes.metadata.storage.region_display_only"
                  component={SelectField}
                  options={regions}
                />
              </Col>
              <Col sm={1}>
                {isLoading && (
                  <ControlLabel>
                    <Icon spin name="spinner" />
                  </ControlLabel>
                )}
              </Col>
            </FormGroup>
            <Field
              name="data.attributes.metadata.options.cruise_cover"
              component={RadioGroup}
              label={'Are you going on a cruise?'}
              labelSize={5}
              inline
              options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
            />

            <Row>
              <Col sm={12} className="policy-upsell-bottom-msg">
                Note: Cancellation Cover is effective from the Start Date of your Annual
                Multi-trip policy
              </Col>
            </Row>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect()(PolicyUpsell);
